{
  "layout": {
    "breadcrumb": "Аккаунт",
    "title": "Профиль",
    "tabs": {
      "profile": "Профиль",
      "security": "Безопасность",
      "mcp": "Ключи MCP"
    }
  },
  "profile": {
    "personalHeading": "Личные данные",
    "personalHint": "Имя и email видят коллеги по компании — в списке сотрудников, командах проектов и письмах.",
    "firstName": "Имя",
    "lastName": "Фамилия",
    "email": "Email",
    "emailConfirmed": "подтверждён",
    "emailPending": "ждёт подтверждения",
    "emailHint": "При смене адреса придёт письмо для подтверждения — до него вход и письма остаются на текущем.",
    "pendingNotice": "Письмо отправлено на <b>{{pending}}</b>. До подтверждения вход и уведомления — по адресу <b>{{email}}</b>.",
    "resend": "Отправить ещё раз",
    "cancelChange": "Отменить смену",
    "passwordConfirmTitle": "Подтвердите смену email",
    "passwordConfirmMessage": "Чтобы сменить адрес для входа на {{email}}, введите текущий пароль.",
    "currentPassword": "Текущий пароль",
    "interfaceHeading": "Интерфейс",
    "interfaceHint": "Хранится в аккаунте и применяется на всех устройствах.",
    "language": "Язык",
    "languageRu": "Русский",
    "languageEn": "English",
    "theme": "Тема",
    "themeDark": "Тёмная",
    "themeLight": "Светлая",
    "save": "Сохранить",
    "saving": "Сохраняем…",
    "cancel": "Отменить"
  },
  "security": {
    "passwordHeading": "Пароль",
    "passwordHint": "Минимум 8 символов. Для смены нужен текущий пароль.",
    "currentPassword": "Текущий пароль",
    "newPassword": "Новый пароль",
    "newPasswordPlaceholder": "Минимум 8 символов",
    "confirmPassword": "Повторите новый",
    "confirmPasswordPlaceholder": "Ещё раз",
    "passwordEffect": "Смена пароля завершит сессии на других устройствах и отзовёт сессии Claude Desktop; API-ключи — во вкладке «Ключи MCP».",
    "changePassword": "Сменить пароль",
    "changingPassword": "Меняем…",
    "sessionsHeading": "Устройства и сессии",
    "sessionsHint": "Выход завершит сессии на всех устройствах, кроме этого. Ссылки на сброс пароля, отправленные раньше, тоже перестанут работать.",
    "signOutEverywhere": "Выйти на всех устройствах",
    "signOutConfirmTitle": "Выйти на всех устройствах?",
    "signOutConfirmMessage": "Сессии на других устройствах и в Claude Desktop завершатся, ссылки на сброс пароля, отправленные раньше, перестанут работать.",
    "signOutConfirmNote": "Это устройство останется в системе. API-ключи продолжат работать.",
    "signOutConfirmLabel": "Выйти везде"
  },
  "mcp": {
    "connectorHeading": "Claude Desktop",
    "connectorHint": "Подключается по этому адресу и вашему логину Frameriver. Ключ для него не нужен.",
    "copyUrl": "Копировать",
    "cliHeading": "Claude Code и API-ключи",
    "cliHint": "Ключ действует с теми же правами, что и ваш логин, и передаётся в заголовке Authorization. Смена пароля ключи не отзывает — отзывайте их здесь.",
    "plaintextHeading": "Скопируйте ключ сейчас",
    "plaintextHint": "Полный ключ показывается только один раз. Сохраните его в Claude и никому не передавайте.",
    "copyToken": "Скопировать ключ",
    "copied": "Скопировано",
    "copyFailed": "Не удалось скопировать",
    "namePlaceholder": "Имя ключа, например Claude Code",
    "create": "Создать ключ",
    "creating": "Создаём…",
    "createHint": "Значение ключа показывается один раз — сразу после создания.",
    "tokensHeading": "Ключи",
    "empty": "Ключей пока нет.",
    "createdAt": "Создан {{date}}",
    "lastUsed": "Последний раз {{date}}",
    "expiresAt": "Истекает {{date}}",
    "revoke": "Отозвать",
    "revokeConfirm": "Отозвать «{{name}}»? Claude перестанет работать, пока не создадите новый ключ.",
    "revoked": "Отозван",
    "expired": "Истёк",
    "oauthHeading": "Сессии Claude Desktop",
    "oauthEmpty": "Активных сессий нет. Они появятся здесь после первого подключения; отзываются кнопкой или при смене пароля.",
    "oauthUnknownClient": "Неизвестное приложение",
    "oauthRevokeConfirm": "Отозвать сессию «{{name}}»? Claude Desktop нужно будет войти снова.",
    "consent": {
      "title": "Разрешить доступ",
      "eyebrow": "Claude / MCP",
      "heading": "Разрешить {{client}} доступ к Frame River?",
      "subtitle": "{{client}} будет действовать как {{email}} — те же проекты и права, что у этого логина.",
      "redirectLabel": "Редирект на",
      "unknownApp": "Неизвестное приложение",
      "allow": "Разрешить",
      "allowing": "Разрешаем…",
      "deny": "Отклонить",
      "denying": "Отклоняем…"
    }
  }
}
